export namespace DialogActions {
  export class OpenLimit {
    static readonly type = '[Dialog] Open Limit';
    constructor() { }
  }

  export class CloseLimit {
    static readonly type = '[Dialog] Close Limit';
    constructor(public upgrade: boolean) { }
  }
  export class OpenPremiumContent {
    static readonly type = '[Dialog] Open Premium Content';
    constructor() { }
  }

  export class ClosePremiumContent {
    static readonly type = '[Dialog] Close Premium Content';
    constructor(public confirmed: boolean) { }
  }

  export class OpenUpgrade {
    static readonly type = '[Dialog] Open Upgrade';
    constructor() { }
  }

  export class CloseUpgrade {
    static readonly type = '[Dialog] Close Upgrade';
    constructor() { }
  }
}
